//悬浮图
import { get, post, postJson, put, deleteApi,putOne } from '../axios2'

const RESOURCE_BASE_PATH = '/suspendingIcon';
const RESOURCE_BASE_PATH2 = '/sellerImage';

//悬浮图列表
export const getIsvActivityList = p => postJson(`${RESOURCE_BASE_PATH}/getIsvActivityList`, p);
//悬浮图标-创建活动
export const addIsvActivity = p => postJson(`${RESOURCE_BASE_PATH}/addIsvActivity`, p);
//悬浮图标-删除关闭活动
export const delIsvActivity = p => deleteApi(`${RESOURCE_BASE_PATH}/${p.id}`);
//悬浮图标-编辑活动
export const editIsvActivity = p => putOne(`${RESOURCE_BASE_PATH}/editIsvActivity`, p);
//获取活动类型最新活动ID
export const getActivityIdByType = p => put(`/pointActivity/getActivityIdByType/1`, p);
//
export const sellerImageList = p => postJson(`${RESOURCE_BASE_PATH2}/list`, p);
//添加图片
export const addImage = p => postJson(`${RESOURCE_BASE_PATH2}`, p);

// 删除 
export const deleteActivity = p => postJson(`/suspendingIcon/delIsvActivity/${p}`);